(() => {
  'use strict';

  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const money = (cents) => new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: window.OLC && OLC.currency ? OLC.currency : 'CAD',
    maximumFractionDigits: (cents % 100 === 0) ? 0 : 2
  }).format(cents / 100);
  const monthly = (cents) => new Intl.NumberFormat('en-CA', {
    style: 'currency', currency: 'CAD', maximumFractionDigits: 0
  }).format(Math.round(cents / 100 / 12));

  /* Toast ------------------------------------------------------------- */
  const toast = $('[data-toast]');
  let toastTimer;
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  /* Mobile navigation -------------------------------------------------- */
  const menuToggle = $('[data-menu-toggle]');
  const menu = $('[data-menu]');
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(open));
      menu.classList.toggle('is-open', open);
    });
  }

  /* Real cart (Shopify Cart AJAX API) ---------------------------------- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartOverlay = $('[data-cart-overlay]');
  const FREE_DELIVERY_CENTS = (window.OLC && OLC.freeDeliveryThreshold) || 399900;

  const openCart = () => {
    document.body.classList.add('cart-open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
  };
  const closeCart = () => {
    document.body.classList.remove('cart-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
  };
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  $('[data-cart-close]')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeSearch(); }
  });

  const renderDrawer = (cart) => {
    const empty = $('[data-cart-empty]');
    const contents = $('[data-cart-contents]');
    const lines = $('[data-cart-lines]');
    $$('[data-cart-count]').forEach((el) => { el.textContent = String(cart.item_count); });
    const summary = $('[data-cart-summary]');
    if (summary) summary.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
    if (empty) empty.hidden = cart.item_count > 0;
    if (contents) contents.hidden = cart.item_count === 0;
    if (lines) {
      lines.innerHTML = cart.items.map((item) => `
        <div class="cart-line" data-line-key="${item.key}">
          ${item.image ? `<img src="${item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_180x180$1$2')}" alt="" loading="lazy">` : '<span></span>'}
          <div>
            <strong><a href="${item.url}">${item.product_title}</a></strong>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${item.variant_title}</span>` : ''}
            <div class="cart-line__qty" aria-label="Quantity">
              <button type="button" data-line-minus aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-line-plus aria-label="Increase quantity">+</button>
            </div>
            <small><button type="button" data-line-remove>Remove</button></small>
          </div>
          <b>${money(item.final_line_price)}</b>
        </div>`).join('');
    }
    const total = $('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    const progress = $('[data-delivery-progress]');
    const progressLabel = $('[data-delivery-label]');
    if (progress && progressLabel) {
      const pct = Math.min(100, Math.round((cart.total_price / FREE_DELIVERY_CENTS) * 100));
      progress.style.width = pct + '%';
      progressLabel.textContent = cart.total_price >= FREE_DELIVERY_CENTS
        ? 'Free delivery unlocked'
        : `${money(FREE_DELIVERY_CENTS - cart.total_price)} away from free delivery*`;
    }
  };

  const fetchCart = () => fetch('/cart.js').then((r) => r.json()).then((cart) => { renderDrawer(cart); return cart; });

  const changeLine = (key, quantity) => fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  }).then((r) => r.json()).then(renderDrawer);

  cartDrawer?.addEventListener('click', (e) => {
    const line = e.target.closest('[data-line-key]');
    if (!line) return;
    const key = line.dataset.lineKey;
    const qtyEl = $('.cart-line__qty span', line);
    const qty = Number(qtyEl ? qtyEl.textContent : 1);
    if (e.target.closest('[data-line-minus]')) changeLine(key, Math.max(0, qty - 1));
    if (e.target.closest('[data-line-plus]')) changeLine(key, qty + 1);
    if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
  });

  const addItems = (items, message) => fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  }).then((r) => {
    if (!r.ok) return r.json().then((err) => { throw err; });
    return r.json();
  }).then(() => fetchCart()).then(() => {
    showToast(message || 'Added to cart');
    openCart();
  }).catch((err) => {
    showToast((err && err.description) || 'Could not add to cart');
  });

  fetchCart();

  /* Wish list (localStorage) ------------------------------------------- */
  const wishKey = 'olcWishList';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(wishKey)) || []; } catch (e) { return []; } };
  $$('.wish-button').forEach((button) => {
    const handle = button.dataset.handle;
    if (handle && readWish().includes(handle)) { button.classList.add('is-active'); button.textContent = '♥'; }
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const active = button.classList.toggle('is-active');
      button.textContent = active ? '♥' : '♡';
      if (handle) {
        const list = readWish().filter((h) => h !== handle);
        if (active) list.push(handle);
        try { localStorage.setItem(wishKey, JSON.stringify(list)); } catch (e) { /* noop */ }
      }
      showToast(active ? 'Saved to your wish list' : 'Removed from your wish list');
    });
  });

  /* PDP image gallery --------------------------------------------------- */
  const galleryMain = $('[data-gallery-main]');
  $$('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      $$('[data-gallery-thumb]').forEach((other) => other.classList.toggle('is-active', other === thumb));
      if (galleryMain) {
        galleryMain.src = thumb.dataset.galleryThumb;
        galleryMain.alt = thumb.dataset.galleryAlt || 'Product image';
      }
    });
  });

  /* Product configurator ------------------------------------------------ */
  const buyBox = $('[data-buy-box]');
  if (buyBox && window.OLC && OLC.product) {
    const product = OLC.product;
    const state = {
      options: {},
      quantity: 1
    };
    let currentVariant = product.variants.find((v) => String(v.id) === String(OLC.selectedVariantId)) || product.variants.find((v) => v.available) || product.variants[0];
    product.options.forEach((name, i) => { state.options[name] = currentVariant.options[i]; });

    const productPrice = $('[data-product-price]');
    const comparePrice = $('[data-compare-price]');
    const saveBadge = $('[data-save-badge]');
    const monthlyPrice = $('[data-monthly-price]');
    const addPrice = $('[data-add-price]');
    const quantityEl = $('[data-quantity]');
    const mobilePrice = $('[data-mobile-price]');
    const mobileVariant = $('[data-mobile-variant]');
    const bundleTotal = $('[data-bundle-total]');
    const addButtons = $$('[data-add-to-cart]');
    const buyNow = $('[data-buy-now]');
    const stockNotice = $('[data-stock-notice]');

    const findVariant = () => product.variants.find((v) =>
      product.options.every((name, i) => v.options[i] === state.options[name])
    );

    const selectedAccessories = () => $$('[data-accessory]:checked').map((f) => ({
      id: Number(f.dataset.variantId),
      quantity: 1,
      price: Number(f.dataset.price)
    }));

    const updateBundleTotal = () => {
      if (!bundleTotal) return;
      const accTotal = selectedAccessories().reduce((s, a) => s + a.price, 0);
      const base = currentVariant ? currentVariant.price * state.quantity : 0;
      bundleTotal.textContent = money(base + accTotal);
    };

    const render = () => {
      const v = currentVariant;
      if (!v) return;
      const total = v.price * state.quantity;
      if (productPrice) productPrice.textContent = money(v.price);
      if (comparePrice) {
        comparePrice.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        comparePrice.hidden = !(v.compare_at_price > v.price);
      }
      if (saveBadge) {
        if (v.compare_at_price > v.price) {
          saveBadge.hidden = false;
          saveBadge.textContent = 'Save ' + money(v.compare_at_price - v.price);
        } else { saveBadge.hidden = true; }
      }
      if (monthlyPrice) monthlyPrice.textContent = monthly(v.price) + '/mo.';
      if (addPrice) addPrice.textContent = money(total);
      if (quantityEl) quantityEl.textContent = String(state.quantity);
      if (mobilePrice) mobilePrice.textContent = money(v.price);
      if (mobileVariant) mobileVariant.textContent = v.title;
      $$('[data-selected-label]').forEach((el) => {
        const name = el.dataset.selectedLabel;
        if (state.options[name]) el.textContent = state.options[name];
      });
      addButtons.forEach((b) => {
        b.disabled = !v.available;
        if (!v.available) b.textContent = 'Sold out';
      });
      if (stockNotice) stockNotice.hidden = !v.available;
      if (v.featured_image && galleryMain && v.featured_image.src) {
        galleryMain.src = v.featured_image.src;
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }
      updateBundleTotal();
    };

    $$('[data-option-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const name = button.dataset.optionName;
        const value = button.dataset.optionValue;
        $$(`[data-option-button][data-option-name="${CSS.escape(name)}"]`).forEach((other) => {
          const active = other === button;
          other.classList.toggle('is-selected', active);
          other.setAttribute('aria-pressed', String(active));
        });
        state.options[name] = value;
        const v = findVariant();
        if (v) currentVariant = v;
        render();
      });
    });

    $('[data-quantity-minus]')?.addEventListener('click', () => { state.quantity = Math.max(1, state.quantity - 1); render(); });
    $('[data-quantity-plus]')?.addEventListener('click', () => { state.quantity = Math.min(9, state.quantity + 1); render(); });
    $$('[data-accessory]').forEach((f) => f.addEventListener('change', updateBundleTotal));

    addButtons.forEach((b) => b.addEventListener('click', () => {
      if (!currentVariant) return;
      addItems([{ id: currentVariant.id, quantity: state.quantity }], `${product.title} added to cart`);
    }));

    $('[data-add-bundle]')?.addEventListener('click', () => {
      if (!currentVariant) return;
      const items = [{ id: currentVariant.id, quantity: state.quantity }].concat(
        selectedAccessories().map((a) => ({ id: a.id, quantity: a.quantity }))
      );
      addItems(items, 'Configured bundle added to cart');
    });

    buyNow?.addEventListener('click', () => {
      if (!currentVariant) return;
      window.location.href = `/cart/${currentVariant.id}:${state.quantity}`;
    });

    render();
  }

  /* Accordions ---------------------------------------------------------- */
  $$('[data-accordion] .accordion__item button').forEach((button) => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      const panel = button.nextElementSibling;
      if (panel) panel.hidden = expanded;
      const icon = $('b', button);
      if (icon) icon.textContent = expanded ? '+' : '−';
    });
  });

  /* Search overlay + predictive search ---------------------------------- */
  const searchPanel = $('[data-search-panel]');
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  const openSearch = () => {
    document.body.classList.add('search-open');
    window.setTimeout(() => searchInput?.focus(), 120);
  };
  const closeSearch = () => document.body.classList.remove('search-open');
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', openSearch));
  $('[data-search-close]')?.addEventListener('click', closeSearch);
  $('[data-search-overlay]')?.addEventListener('click', closeSearch);

  let searchTimer;
  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { searchResults?.classList.remove('has-results'); return; }
    searchTimer = window.setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`)
        .then((r) => r.json())
        .then((data) => {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!searchResults) return;
          if (!products.length) { searchResults.classList.remove('has-results'); return; }
          $('[data-search-results-grid]', searchResults).innerHTML = products.map((p) => `
            <a class="search-result" href="${p.url}">
              ${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : '<span></span>'}
              <span><strong>${p.title}</strong><span>${p.price ? 'From $' + p.price : ''}</span></span>
            </a>`).join('');
          const all = $('[data-search-all]', searchResults);
          if (all) all.href = `/search?q=${encodeURIComponent(q)}&type=product`;
          searchResults.classList.add('has-results');
        }).catch(() => { /* noop */ });
    }, 220);
  });

  /* Collection sort ------------------------------------------------------ */
  $('[data-sort-select]')?.addEventListener('change', (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Prevent empty demo links from jumping ------------------------------- */
  $$('a[href="#"]').forEach((link) => link.addEventListener('click', (e) => e.preventDefault()));
})();
